// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2ZPIc","value":"style_value__1N3FT"};